import { create } from 'zustand';

type MainMenuState = {
	menuIsOpen: boolean;
	setMenuIsOpen: (value: boolean) => void;

	activeItemMain: string | null;
	setActiveItemMain: (id: string | null) => void;

	activeItemSecondary: string | null;
	setActiveItemSecondary: (id: string | null) => void;

	activeItemLevel1: string | null;
	setActiveItemLevel1: (id: string | null) => void;
	toggleActiveItemLevel1: (id: string | null) => void;

	activeItemLevel2: string | null;
	setActiveItemLevel2: (id: string | null) => void;
	toggleActiveItemLevel2: (id: string | null) => void;

	activeSubMenu: string | null;
	setActiveSubMenu: (id: string | null) => void;
	toggleActiveSubMenu: (id: string | null) => void;

	clearMainMenuStates: () => void;
};

export const useMainMenuState = create<MainMenuState>((set) => ({
	menuIsOpen: false,
	setMenuIsOpen: (isOpen) => {
		set({ menuIsOpen: isOpen });
	},

	activeItemMain: null,
	setActiveItemMain: (id) =>
		set({
			activeItemMain: id,
			activeItemSecondary: null,
			activeItemLevel1: null,
			activeItemLevel2: null,
		}),

	activeItemSecondary: null,
	setActiveItemSecondary: (id) =>
		set({
			activeItemSecondary: id,
			activeItemLevel1: null,
			activeItemLevel2: null,
		}),

	activeItemLevel1: null,
	setActiveItemLevel1: (id) =>
		set({
			activeItemLevel1: id,
			activeItemLevel2: null,
		}),
	toggleActiveItemLevel1: (id) => set((oldData) => ({ activeItemLevel1: oldData.activeItemLevel1 === id ? null : id })),

	activeItemLevel2: null,
	setActiveItemLevel2: (id) =>
		set({
			activeItemLevel2: id,
		}),
	toggleActiveItemLevel2: (id) => set((oldData) => ({ activeItemLevel2: oldData.activeItemLevel2 === id ? null : id })),

	activeSubMenu: null,
	setActiveSubMenu: (id) => set({ activeSubMenu: id }),
	toggleActiveSubMenu: (id) => set((oldData) => ({ activeSubMenu: oldData.activeSubMenu === id ? null : id })),

	clearMainMenuStates: () =>
		set({
			menuIsOpen: false,
			activeItemMain: null,
			activeItemSecondary: null,
			activeItemLevel1: null,
			activeItemLevel2: null,
			activeSubMenu: null,
		}),
}));

export default useMainMenuState;
